import { phappsRequest } from './apiService';
import { buildTaskPath } from '@/config/apiConstants';

const p = (path, params) => {
  const base = buildTaskPath(path);
  if (!params) return base;
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
  ).toString();
  return qs ? `${base}?${qs}` : base;
};

// ---- Board tasks ----
export const getTasks      = (params)        => phappsRequest(p('tasks', params), 'GET');
export const getTask       = (id)            => phappsRequest(p(`tasks/${id}`), 'GET');
export const createTask    = (body)          => phappsRequest(p('tasks'), 'POST', body);
export const updateTask    = (id, body)      => phappsRequest(p(`tasks/${id}`), 'PUT', body);
export const moveTask      = (id, due_date)  => phappsRequest(p(`tasks/${id}/move`), 'PUT', { due_date });
export const completeTask  = (id)            => phappsRequest(p(`tasks/${id}/complete`), 'POST', {});
export const reopenTask    = (id)            => phappsRequest(p(`tasks/${id}/reopen`), 'POST', {});
export const deleteTask    = (id)            => phappsRequest(p(`tasks/${id}`), 'DELETE');

// ---- Overdue / calendar ----
export const getOverdueCounts = ()           => phappsRequest(p('overdue-counts'), 'GET');
export const getOverdueTasks  = ()           => phappsRequest(p('tasks/overdue'), 'GET');
export const bulkUpdateTasks  = (body)       => phappsRequest(p('tasks/bulk'), 'POST', body);
export const getMyTodayCount  = ()           => phappsRequest(p('tasks/today-count'), 'GET');
export const getCalendar      = (params)     => phappsRequest(p('calendar', params), 'GET');

// ---- Archive (completed tasks) ----
export const getArchive    = (params)        => phappsRequest(p('tasks/archive', params), 'GET');

// ---- Staff (colour legend / assignment) ----
export const getStaff      = ()              => phappsRequest(p('staff'), 'GET');
export const setStaffColor = (id, task_color) => phappsRequest(p(`staff/${id}/color`), 'PUT', { task_color });

// ---- Chemists (tag a pharmacy onto a task/event) ----
export const searchChemists = (search)       => phappsRequest(p('chemists', search ? { search } : undefined), 'GET');

// ---- Personal to-do list ----
export const getTodos      = ()              => phappsRequest(p('todos'), 'GET');
export const createTodo    = (text)          => phappsRequest(p('todos'), 'POST', { text });
export const updateTodo    = (id, body)      => phappsRequest(p(`todos/${id}`), 'PUT', body);
export const deleteTodo    = (id)            => phappsRequest(p(`todos/${id}`), 'DELETE');
export const promoteTodo   = (id, body)      => phappsRequest(p(`todos/${id}/promote`), 'POST', body);

// ---- Comments ----
export const getComments   = (taskId)        => phappsRequest(p(`tasks/${taskId}/comments`), 'GET');
export const addComment    = (taskId, comment) => phappsRequest(p(`tasks/${taskId}/comments`), 'POST', { comment });
export const deleteComment = (commentId)     => phappsRequest(p(`comments/${commentId}`), 'DELETE');

// ---- Attachments ----
export const getAttachments   = (taskId)     => phappsRequest(p(`tasks/${taskId}/attachments`), 'GET');
export const deleteAttachment = (attId)      => phappsRequest(p(`attachments/${attId}`), 'DELETE');

/** Multipart upload — phappsRequest only handles JSON, so build the request directly. */
export const uploadAttachment = async (taskId, file) => {
  const token = localStorage.getItem('jwtToken');
  const form = new FormData();
  form.append('file', file);
  const url = `${import.meta.env.VITE_APP_DATA_API_URL}${buildTaskPath(`tasks/${taskId}/attachments`)}`;
  const res = await fetch(url, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });
  if (!res.ok) {
    let msg = `Upload failed (${res.status})`;
    try { const j = await res.json(); msg = j.message || j.error || msg; } catch { /* noop */ }
    throw new Error(msg);
  }
  return res.json();
};

/** Authenticated download — fetch as blob then trigger a browser save. */
export const downloadAttachment = async (attId, filename) => {
  const token = localStorage.getItem('jwtToken');
  const url = `${import.meta.env.VITE_APP_DATA_API_URL}${buildTaskPath(`attachments/${attId}/download`)}`;
  const res = await fetch(url, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!res.ok) throw new Error(`Download failed (${res.status})`);
  const blob = await res.blob();
  const objectUrl = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = filename || 'attachment';
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(objectUrl);
};
